import { render, staticRenderFns } from "./ChatRefUnknown.vue?vue&type=template&id=0cecd3f3&"
import script from "./ChatRefUnknown.vue?vue&type=script&lang=js&"
export * from "./ChatRefUnknown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports